import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AdvancedSecurityOption: LazyOption = createLazyOption(
    {
        key: 'advancedSecurity',
        titleStringKey: 'optionTitle_premium_advanced_security',
        searchTermsStringKey: 'optionTitle_premium_advanced_security',
        isHidden: () =>
            isFeatureEnabled('auth-PremiumDashboardApril') ||
            !isFeatureEnabled('auth-PremiumDashboard') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default AdvancedSecurityOption;
